import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { fetchEnterpriseOverview } from "../api/enterpriseClient";

export const enterpriseOverviewQueryOptions = (customerId: number) =>
  queryOptions({
    queryKey: ["enterprise-overview", customerId],
    queryFn: () => fetchEnterpriseOverview(customerId),
    staleTime: 60_000,
  });

export function useGetEnterpriseOverview(customerId: number) {
  return useSuspenseQuery(enterpriseOverviewQueryOptions(customerId));
}
